/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useState, useContext } from 'react';
import {
  Card,
  Stack,
  Tabs,
  TabList,
  Tab,
  HStack,
  Spinner,
  Text,
  useDisclosure,
} from '@mybridge/ui';
import { PublicProfileContext } from 'v4/components/public-profile/context';
import styles from './photos.module.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import _ from 'lodash';
import DashboardReelModal from 'v4/components/ReelModal/DashboardReelModal';
import ImageModal from 'v4/components/imageModal/ImageModal';
import { Link } from '@mybridge/ui/link';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const PublicProfilePhotos = ({linkForVideos}) => {
  const {
    publicProfile,
    userProfileInfo,
    aggregatedPhotosData,
    refetchAgregatedPhotos,
    photosOfYouCount,
    hasPhotosOfYou,
    photosOfYou,
    refetchPhotosOfyou,
    photosOfYouHasNextPage,
    photosOfYouFetchNextPage,
    yourPhotos,
    yourPhotosCount,
    hasYourPhotos,
    refetchYourPhotos,
    yourPhotosHasNextPage,
    yourPhotosFetchNextPage,
    coverPhotos,
    hasCoverPhotos,
    coverPhotoCount,
    refetchCoverPhotos,
    coverPhotosHasNextPage,
    coverPhotosFetchNextPage,
    profilePhotos,
    hasProfilePhotos,
    profilePhotoCount,
    refetchProfilePhotos,
    profilePhotosHasNextPage,
    profilePhotosFetchNextPage,
    yourVideos,
    hasYourVideos,
    yourVideosCount,
    refetchyourVideos,
    yourVideosHasNextPage,
    yourVideosFetchNextPage,
    videosOfYou,
    hasVideosOfYou,
    videosOfYouCount,
    refetchvideosOfYou,
    videosOfYouHasNextPage,
    videosOfYouFetchNextPage,
  } = useContext(PublicProfileContext);

  const [activeTab, setActiveTab] = useState(0);
  const [isAggregatedCards, setIsAggregatedCards] = useState(false);
  const [aggregtedTabIndex, setAggregatedTabIndex] = useState(null);
  const [aggregatedTabs, setAggregatedTabs] = useState([]);
  const audienceCreateDisc = useDisclosure();
  const { t } = useTranslator();
  const [activeVideoTab, setActiveVideoTab] = useState(0);

  const [aggregatedData, setAggregatedData] = useState(null);

  const [reelModel, setReelModel] = useState(false);
  const [reelModelProps, setReelModelProps] = useState({
    postsData: [],
    onClose: () => {},
    fetchNext: () => {},
    hasMore: true,
    postIndex: 0,
    postMediaIndex: 0,
  });

  const [imageModel, setImageModel] = useState(false);
  const [imageModelProps, setImageModelProps] = useState({
    postsData: [],
    onClose: () => {},
    fetchNext: () => {},
    hasMore: true,
    postIndex: 0,
    postMediaIndex: 0,
  });

  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    setAggregatedData(aggregatedPhotosData);
    if (aggregatedPhotosData) {
      setAggregatedTabs(Object.keys(aggregatedPhotosData));
    }
  }, [aggregatedPhotosData]);

  useEffect(() => {
    if (publicProfile) {
      setIsInitialLoading(true);
      // Fetch all necessary data when component mounts
      Promise.all([
        refetchAgregatedPhotos?.({ user: publicProfile.slug, company: '1' }),
        refetchPhotosOfyou?.({ slug: publicProfile.slug }),
        refetchYourPhotos?.({ user: publicProfile.slug }),
        refetchyourVideos?.({ user: publicProfile.slug }),
        refetchvideosOfYou?.({ user: publicProfile.slug })
      ]).then(() => {
        setIsInitialLoading(false);
      }).catch(err => {
        console.error("Error fetching photo data:", err);
        setIsInitialLoading(false);
      });
    }
  }, [publicProfile]);

  useEffect(() => {
    if (publicProfile) {
      if (aggregtedTabIndex === 'cover') {
        refetchCoverPhotos?.();
      } else if (aggregtedTabIndex === 'profile') {
        refetchProfilePhotos?.();
        refetchYourPhotos?.({ user: publicProfile.slug });
      } else if (aggregtedTabIndex === 'others') {
        refetchYourPhotos?.({ user: publicProfile.slug });
      } else if (aggregtedTabIndex === 'tagged') {
        refetchPhotosOfyou?.({ slug: publicProfile.slug });
        refetchYourPhotos?.({ user: publicProfile.slug });
      } else {
        refetchAgregatedPhotos?.({ user: publicProfile.slug, company: '1' });
        refetchPhotosOfyou?.({ slug: publicProfile.slug });
        refetchYourPhotos?.({ user: publicProfile.slug });
        refetchyourVideos?.({ user: publicProfile.slug });
        refetchvideosOfYou?.({ user: publicProfile.slug });
      }
    }
  }, [aggregtedTabIndex, publicProfile]);

  const PhotosTabsArray = [
    {
      title: `${t('publicProfile.photosOf') || "Photos of"} ${publicProfile.first_name}`,
    },
    {
      title: `${publicProfile.first_name}'s ${t('profilePhotosVideos.photos') || "Photos"}`,
    },
  ];
  const VideosTabsArray = [
    {
      title: `${t('publicProfile.videosOf') || "Videos of"} ${publicProfile.first_name}`,
    },
    {
      title: `${publicProfile.first_name}'s ${t('profilePhotosVideos.videos') || "Videos"}`,
    },
  ];

  const aggregatedCardKeys = {
    "cover": t('profilePhotosVideos.coverPhotos') || "Cover photos",
    "profile": t('profilePhotosVideos.profilePictures') || "Profile pictures", 
    "tagged": t('profilePhotosVideos.tagged') || "Tagged",
    "others": t('profilePhotosVideos.others') || "Others"
  }

  return (
    <>
      {!isAggregatedCards && (
        <>
          <Card variant="thinBorderedCard" mb={6} p={4}>
            <Stack>
              <div className={styles.imgCont1}>
                {aggregatedData &&
                  Object.keys(aggregatedData).map((key, index) => {
                    if (aggregatedData[key].count > 0) {
                      return (
                        <div
                          className={styles.card1}
                          key={index}
                          onClick={() => {
                            // setIsAggregatedCards(true);
                            // setAggregatedTabIndex(key);
                            if (key === 'others') {
                              setActiveTab(1);
                            } else {
                              setIsAggregatedCards(true);
                              setAggregatedTabIndex(key);
                            }
                          }}
                        >
                          <div>
                            <img
                              src={aggregatedData[key].thumbnail}
                              alt="sample image"
                              className={styles.img1}
                            />
                          </div>
                          <div className={styles.txtCont1}>
                            {aggregatedCardKeys[key]}
                          </div>
                          <div className={styles.txtCont2}>
                            {aggregatedData[key].count} {t('profilePhotosVideos.items') || "items"}
                          </div>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })}
              </div>
            </Stack>
            <Stack minH="300px">
              <Tabs index={activeTab} mb="24px">
                <TabList borderBottomColor="transparent">
                  {PhotosTabsArray.map((t, index) => (
                    <div key={index} onClick={() => setActiveTab(index)}>
                      <Tab>{t?.title}</Tab>
                    </div>
                  ))}
                </TabList>
              </Tabs>
              {activeTab === 0 && (
                <CustomInfiniteScroll
                  dataLength={photosOfYouCount}
                  next={photosOfYouFetchNextPage}
                  hasMore={photosOfYouHasNextPage}
                  isPhotos={hasPhotosOfYou}
                  photosArray={photosOfYou}
                  setImageModel={setImageModel}
                  setImageModelProps={setImageModelProps}
                />
              )}
              {activeTab === 1 && (
                <CustomInfiniteScroll
                  dataLength={yourPhotosCount}
                  next={yourPhotosFetchNextPage}
                  hasMore={yourPhotosHasNextPage}
                  isPhotos={hasYourPhotos}
                  photosArray={yourPhotos}
                  setImageModel={setImageModel}
                  setImageModelProps={setImageModelProps}
                />
              )}
            </Stack>
          </Card>

          {/* <Card variant="thinBorderedCard" mb={6} p={4}>
            <div className={styles.headerCont2}>
              <div className={styles.heading1}>{t('profilePhotosVideos.videos') || "Videos"}</div>
              <div className={styles.linkText}>
                {yourVideos.length > 0 && <a href='#' onClick={linkForVideos}>{t('profilePhotosVideos.seeAll') || "See all"}</a>}
              </div>
            </div>
            <Stack minH="300px">
              <Tabs index={activeVideoTab} mb={6}>
                <TabList borderBottomColor="transparent">
                  {VideosTabsArray.map((t, index) => (
                    <div key={index} onClick={() => setActiveVideoTab(index)}>
                      <Tab>{t?.title}</Tab>
                    </div>
                  ))}
                </TabList>
              </Tabs>
              {activeVideoTab === 0 && (
                <CustomInfiniteVideoScroll
                  dataLength={videosOfYouCount}
                  next={videosOfYouFetchNextPage}
                  hasMore={videosOfYouHasNextPage}
                  isVideos={hasVideosOfYou}
                  videosArray={videosOfYou}
                  setReelModel={setReelModel}
                  setReelModelProps={setReelModelProps}
                />
              )}
            </Stack>

            {activeVideoTab === 1 && (
              <CustomInfiniteVideoScroll
                dataLength={yourVideosCount}
                next={yourVideosFetchNextPage}
                hasMore={yourVideosHasNextPage}
                isVideos={hasYourVideos}
                videosArray={yourVideos}
                setReelModel={setReelModel}
                setReelModelProps={setReelModelProps}
              />
            )}
          </Card> */}
        </>
      )}

      {reelModel && <DashboardReelModal {...reelModelProps} />}
      {imageModel && <ImageModal {...imageModelProps} />}

      {isAggregatedCards && (
        <>
          <Card variant="thinBorderedCard" mb={2.5} p={4}>
            <div
              className={styles.headerCont1}
              onClick={() => {
                setAggregatedTabIndex(null);
                setIsAggregatedCards(false);
              }}
            >
              <p className={styles.heading1}>{aggregatedCardKeys[aggregtedTabIndex]}</p>
              <p className={styles.para1}>
                {aggregatedData?.[aggregtedTabIndex]?.count}&nbsp;{t('profilePhotosVideos.items') || "items"}
              </p>
            </div>
          </Card>

          <Card variant="thinBorderedCard" mb={2.5} p={4} minH="300px">
            {aggregtedTabIndex === 'cover' && (
              <CustomInfiniteScroll
                dataLength={coverPhotoCount}
                next={coverPhotosFetchNextPage}
                hasMore={coverPhotosHasNextPage}
                isPhotos={hasCoverPhotos}
                photosArray={coverPhotos}
                setImageModel={setImageModel}
                setImageModelProps={setImageModelProps}
              />
            )}
            {aggregtedTabIndex === 'profile' && (
              <CustomInfiniteScroll
                dataLength={profilePhotoCount}
                next={profilePhotosFetchNextPage}
                hasMore={profilePhotosHasNextPage}
                isPhotos={hasProfilePhotos}
                photosArray={profilePhotos}
                setImageModel={setImageModel}
                setImageModelProps={setImageModelProps}
              />
            )}
            {aggregtedTabIndex === 'tagged' && (
              <CustomInfiniteScroll
                dataLength={photosOfYouCount}
                next={photosOfYouFetchNextPage}
                hasMore={photosOfYouHasNextPage}
                isPhotos={hasPhotosOfYou}
                photosArray={photosOfYou}
                setImageModel={setImageModel}
                setImageModelProps={setImageModelProps}
              />
            )}
            {aggregtedTabIndex === 'others' && (
              <CustomInfiniteScroll
                dataLength={yourPhotosCount}
                next={yourPhotosFetchNextPage}
                hasMore={yourPhotosHasNextPage}
                isPhotos={hasYourPhotos}
                photosArray={yourPhotos}
                setImageModel={setImageModel}
                setImageModelProps={setImageModelProps}
              />
            )}
          </Card>
        </>
      )}
    </>
  );
};

const CustomInfiniteScroll = ({
  dataLength = 0,
  next,
  hasMore =false,
  isPhotos,
  photosArray,
  setImageModelProps,
  setImageModel
}) => {
  const { t } = useTranslator();
  return (
    <>
      <InfiniteScroll
        className={styles.imgCont2}
        dataLength={dataLength}
        next={next}
        hasMore={!!hasMore}
        loader={
          <HStack p={4} justifyContent="center" w="100%">
            <Spinner />
          </HStack>
        }
        endMessage={
          <Text style={{ textAlign: 'center' }} py={3}>
            {isPhotos ? '' : t('profilePhotosVideos.noPhotos') || 'No photos to show'}
          </Text>
        }
      >
        {isPhotos &&
          photosArray.map((Img, i) =>
            Img?.media?.length > 1 ? (
              Img?.media?.map((MultiImg, multiIndex) => (
                <div className={styles.card2} key={multiIndex}>
                  <img
                    src={MultiImg?.file}
                    alt="post image"
                    className={styles.img2}
                    onClick={() => {
                      const props = {
                        onClose: () => setImageModel(false),
                        postsData: photosArray,
                        fetchNext: next,
                        hasMore: hasMore,
                        postIndex: i,
                        postMediaIndex: multiIndex,
                      };
                      setImageModelProps(props);
                      setImageModel(true);
                    }}
                  />
                </div>
              ))
            ) : (
              <div className={styles.card2}>
                <img
                  src={Img.media?.[0]?.file}
                  alt="post image"
                  className={styles.img2}
                  onClick={() => {
                    const props = {
                      onClose: () => setImageModel(false),
                      postsData: photosArray,
                      fetchNext: next,
                      hasMore: hasMore,
                      postIndex: i,
                      postMediaIndex: 0,
                    };
                    setImageModelProps(props);
                    setImageModel(true);
                  }}
                />
              </div>
            )
          )}
      </InfiniteScroll>
    </>
  );
};

const CustomInfiniteVideoScroll = ({
  dataLength = 0,
  next,
  hasMore = false,
  isVideos,
  videosArray,
  setReelModel,
  setReelModelProps,
}) => {
  const { t } = useTranslator();
  return (
    <>
      <InfiniteScroll
        className={styles.imgCont2}
        dataLength={dataLength}
        next={next}
        hasMore={!!hasMore}
        loader={
          <HStack p={4} justifyContent="center" w="100%">
            <Spinner />
          </HStack>
        }
        endMessage={
          <Text style={{ textAlign: 'center' }} py={3}>
            {isVideos ? '' : t('profilePhotosVideos.noVideos') || 'No Videos to show'}
          </Text>
        }
      >
        {isVideos &&
          videosArray.map((vid, i) =>
            vid.media?.length > 1 ? (
              vid?.media?.map((MultiVid, multiIndex) => (
                <div className={styles.card2} key={multiIndex}>
                  <video
                    src={MultiVid?.file}
                    alt="post image"
                    className={styles.vid1}
                    onClick={() => {
                      const props = {
                        onClose: () => setReelModel(false),
                        postsData: videosArray,
                        fetchNext: next,
                        hasMore: hasMore,
                        postIndex: i,
                        postMediaIndex: multiIndex,
                      };
                      setReelModelProps(props);
                      setReelModel(true);
                    }}
                  />
                  <div className={styles.videoLengthCont}>00:00</div>
                </div>
              ))
            ) : (
              <div className={styles.card2}>
                <video
                  src={vid.media?.[0]?.file}
                  alt="post image"
                  className={styles.vid1}
                  onClick={() => {
                    const props = {
                      onClose: () => setReelModel(false),
                      postsData: videosArray,
                      fetchNext: next,
                      hasMore: hasMore,
                      postIndex: i,
                      postMediaIndex: 0,
                    };
                    setReelModelProps(props);
                    setReelModel(true);
                  }}
                />
                <div className={styles.videoLengthCont}>00:00</div>
              </div>
            )
          )}
      </InfiniteScroll>
    </>
  );
};
